module.exports = "<p>\n  usage-instructions works!\n</p>\n"